module.exports = __webpack_public_path__ + "img/ic_xianchang.4d5e9e45.png";